import permissionsService from './permissionsService'

export default {
  methods: {
    m_hasRolePermission({ permission, module, section }) {
      return permissionsService.hasRolePermission({ permission, module, section })
    },
    m_hasPermissionOrFallback({ permission, module, section, fallbackRoles = [], allRoles = false }) {
      return permissionsService.hasPermissionOrFallback({ permission, module, fallbackRoles, allRoles, section })
    }
  }
}
